import { Box, getThemeColor, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Card = styled(Box)`
  width: 100%;
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  border-radius: 16px;
`
